export function initSuccessRates() {
    const counterElements = document.querySelectorAll('[data-counter]');
    const progressBars = document.querySelectorAll('[data-progress-bar]');
    
    if (!counterElements.length && !progressBars.length) return;

    let hasAnimated = false;

    const animateCounter = (element) => {
        const text = element.textContent;
        const hasPercentage = text.includes('%');
        const hasRating = text.includes('/');
        
        let numberToAnimate;
        let suffix = '';
        let prefix = '';
        
        if (hasRating) {
            // Extract the first number from ratings like "4.8/5"
            const match = text.match(/([\d.]+)\s*\/\s*([\d.]+)/);
            if (match) {
                numberToAnimate = parseFloat(match[1]);
                suffix = `/${match[2]}`;
            }
        } else if (hasPercentage) {
            // Extract number from percentage like "45%"
            const match = text.match(/([\d.]+)\s*%/);
            if (match) {
                numberToAnimate = parseFloat(match[1]);
                suffix = '%';
            }
        } else {
            // Plain number
            numberToAnimate = parseFloat(text.replace(/[^\d.-]/g, ''));
        }
        
        if (isNaN(numberToAnimate)) return;
        
        const duration = 2000;
        const steps = 60;
        const increment = numberToAnimate / steps;
        const decimals = (numberToAnimate % 1 !== 0) ? (numberToAnimate.toString().split('.')[1]?.length || 1) : 0;
        
        let currentValue = 0;
        let stepCount = 0;
        
        const updateCounter = () => {
            stepCount++;
            currentValue = Math.min(currentValue + increment, numberToAnimate);
            
            const displayValue = decimals > 0 
                ? currentValue.toFixed(decimals) 
                : Math.floor(currentValue);
            
            element.textContent = `${prefix}${displayValue}${suffix}`;
            
            if (stepCount < steps) {
                requestAnimationFrame(updateCounter);
            } else {
                element.textContent = `${prefix}${numberToAnimate}${suffix}`;
            }
        };
        
        requestAnimationFrame(updateCounter);
    };

    const animateProgressBar = (element) => {
        const targetWidth = parseFloat(element.getAttribute('data-target-width'));

        if (isNaN(targetWidth)) return;

        const visualWidth = Math.max(12, targetWidth);
        const duration = 2000;
        const steps = 60;
        const increment = visualWidth / steps;

        let currentWidth = 0;
        let stepCount = 0;

        const updateProgress = () => {
            stepCount++;
            currentWidth = Math.min(currentWidth + increment, visualWidth);

            element.style.width = `${currentWidth}%`;

            if (stepCount < steps) {
                requestAnimationFrame(updateProgress);
            } else {
                element.style.width = `${visualWidth}%`;
            }
        };
        
        requestAnimationFrame(updateProgress);
    };

    const triggerAllAnimations = () => {
        if (hasAnimated) return;
        hasAnimated = true;
        
        // Animate all counters
        counterElements.forEach(element => {
            animateCounter(element);
        });
        
        // Animate all progress bars
        progressBars.forEach(element => {
            animateProgressBar(element);
        });
    };

    const observerOptions = {
        threshold: 0.3,
        rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                triggerAllAnimations();
                observer.disconnect();
            }
        });
    }, observerOptions);

    // Observe the first counter and first progress bar independently —
    // whichever enters the viewport first triggers all animations.
    // This handles page reloads where scroll is already at the chart section
    // (counters above the fold) or at the counters (bars below the fold).
    if (counterElements.length > 0) {
        observer.observe(counterElements[0]);
    }
    if (progressBars.length > 0) {
        observer.observe(progressBars[0]);
    }
}

